import React, { useMemo, useState } from "react";
import BottomToolBar from "./BottomToolBar";
import TopToolBar from "./TopToolBar";
import { Box, Container } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { buildRowActions } from "./RowActionMenu";
import { buildColumnsCuentaCorrienteEnvasado } from "../config/columns";
import { MRT_Localization_ES } from "material-react-table/locales/es";

const CuentaCorrienteTable = ({
  data = [],
  totales = {},
  loading,
  onAction = () => {},
  onToolbarAction = () => {},
  showToast,
  filtrosActivos,
  variant,
  cantidadDeRecibosPendientes,
  countNotes,
}) => {
  const [copiedId, setCopiedId] = useState(null);

  const columns = useMemo(
    () =>
      buildColumnsCuentaCorrienteEnvasado({
        variant,
        totales,
        copiedId,
        setCopiedId,
      }),
    [variant, totales, copiedId],
  );

  const estaVencidaConSaldoPendiente = (
    comprobante,
    fechaVencimiento,
    saldoPendiente,
  ) => {
    if (String(comprobante).toLocaleLowerCase() !== "factura") return false;
    return (
      saldoPendiente > 0 && new Date(fechaVencimiento).getTime() < Date.now()
    );
  };

  const dataConEstado = useMemo(() => {
    return data.map((row) => ({
      ...row,
      _vencidaConSaldoPendiente: estaVencidaConSaldoPendiente(
        row.comprobante,
        row.fecha_vencimiento,
        row.saldoImputado ?? row.pendiente,
      ),
    }));
  }, [data]);

  console.log("DataConEstado: ", dataConEstado);

  //#region Configuraciones de la tabla
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageIndex: 0,
      pageSize: 100,
    },
  };

  const bgColorTableHeadCell = "rgba(212, 230, 241, 0.8)";

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 14,
      color: "black",
      fontWeight: "normal",
      paddingTop: 1,
      paddingBottom: 1,
      backgroundColor: bgColorTableHeadCell,
      borderColor: "#FDFEFE",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        sx: {
          fontSize: 14,
          color: "black",
          fontWeight: "normal",
          paddingTop: 1,
          paddingBottom: 1,
          backgroundColor: bgColorTableHeadCell,
          borderColor: "#FDFEFE",
        },
      },
      size: 60,
    },
  };
  //#endregion

  return (
    <Container maxWidth="xl" disableGutters>
      <Box boxShadow={3}>
        <MaterialReactTable
          renderTopToolbarCustomActions={() => (
            <TopToolBar
              variant={variant}
              onAction={onToolbarAction}
              cantidadDeRecibosPendientes={cantidadDeRecibosPendientes}
              filtrosActivos={filtrosActivos}
            />
          )}
          renderBottomToolbarCustomActions={() => (
            <BottomToolBar
              onAction={onToolbarAction}
              variant={variant}
              contadorDeNotas={countNotes}
            />
          )}
          muiTableBodyRowProps={({ row }) => {
            const { debe, haber } = row.original;

            let color = "inherit";

            if (debe) color = "success.main";
            if (haber) color = "error.main";

            return {
              sx: {
                "& td": {
                  color,
                  fontWeight: 600,
                },
              },
            };
          }}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          localization={MRT_Localization_ES}
          columns={columns}
          data={dataConEstado}
          enableSorting={false}
          enableColumnFilterModes={false}
          enableColumnOrdering={false}
          enableGrouping={false}
          enableRowActions
          muiTableContainerProps={{
            sx: {
              maxHeight: "47vh",
            },
          }}
          enableStickyFooter
          enableStickyHeader
          initialState={initialState}
          state={{
            isLoading: loading,
            showSkeletons: loading,
            showLoadingOverlay: loading,
          }}
          enableRowSelection={false}
          positionActionsColumn="last"
          enableHiding={false}
          muiTableHeadCellProps={tableHeadCellProps}
          positionExpandColumn="first"
          enableExpandAll={false}
          muiTableFooterCellProps={{
            sx: {
              backgroundColor: bgColorTableHeadCell,
              borderColor: "#FDFEFE",
            },
          }}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
            sx: {
              backgroundColor: row.original._vencidaConSaldoPendiente
                ? row.index % 2 === 0
                  ? "#FEF3C7"
                  : "#ffeea8"
                : row.index % 2 === 0
                  ? "#ffffff"
                  : "#fafafa",

              color: "black",
              borderBottom: "1px solid rgba(224,224,224,1)",

              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            },
            hover: true,
          })}
          enableColumnActions={false}
          enableColumnFilters={false}
          displayColumnDefOptions={displayColumnDefOptions}
          enableDensityToggle={false}
          renderRowActionMenuItems={({ closeMenu, row }) =>
            buildRowActions({ row: row.original, closeMenu, onAction, variant })
          }
        />
      </Box>
    </Container>
  );
};

export default CuentaCorrienteTable;
